import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-card-example',
  templateUrl: './card.component.html',
})
export class KitBootstrapCardExampleComponent {}
